/**
 * Mapper utility to convert EmaraTax API response to business profile form values
 * @param {Object} apiResponse - The EmaraTax API response
 * @param {Object} options - Additional options for mapping
 * @param {Array} options.registrationTypeOptions - List of registration type options for mapping legalType
 * @returns {Object} - Object with form field paths as keys and values to set
 */
export const mapEmaraTaxResponseToFormValues = (apiResponse, options = {}) => {
  const { registrationTypeOptions = [] } = options;
  const formValues = {};

  if (!apiResponse) {
    return formValues;
  }

  // entityNameEn -> party_name (Business Name) and name
  if (apiResponse.entityNameEn) {
    formValues.party_name = apiResponse.entityNameEn;
    formValues.name = apiResponse.entityNameEn;
  }

  // entityNameAr -> party_name_in_local_language
  if (apiResponse.entityNameAr) {
    formValues.party_name_in_local_language = apiResponse.entityNameAr;
  }

  // email -> email
  if (apiResponse.email) {
    formValues.email = apiResponse.email;
  }

  // TIN -> tin
  if (apiResponse.TIN) {
    formValues.tin = apiResponse.TIN;
  }

  // mobile -> telephone (format with +971 if not already formatted)
  if (apiResponse.mobile) {
    let phoneNumber = apiResponse.mobile;
    // If mobile doesn't start with +, assume it's UAE and add +971
    if (!phoneNumber.startsWith('+')) {
      phoneNumber = `+971${phoneNumber}`;
    }
    formValues.telephone = phoneNumber;
  }

  // vatTrn -> party_tax_scheme.company_id (VAT)
  if (apiResponse.vatTrn) {
    formValues['party_tax_scheme.company_id'] = apiResponse.vatTrn;
  }

  // Set default tax scheme to VAT
  formValues['party_tax_scheme.tax_scheme'] = 'VAT';

  return formValues;
};
